import { BaseModel } from './base-model';
import { ZoneFeature } from './zones-base-interfaces';

export abstract class WhaleZonesModelBase extends BaseModel
{
    abstract allZones(): Promise<ZoneFeature[] | null>;
    abstract allActiveZones(fromDate: Date, toDate: Date): Promise<ZoneFeature[] | null>;
}

let WhaleZonesModel: WhaleZonesModelBase|null = null;

function setWhaleZonesModel(model: WhaleZonesModelBase)
{
    WhaleZonesModel = model;
}

export { WhaleZonesModel, setWhaleZonesModel };